<template>
  <div class="LoginLayout">
    <h1 class="FormTitle">{{ title }}</h1>
    <form>
      <slot></slot>
      <lm-button
        class="MainButton"
        type="primary"
        :loading="submitting"
        @click.prevent="submit"
      >
        {{ buttonTitle }}
      </lm-button>
    </form>
    <router-link
      v-show="type === 'login'"
      :to="{name: 'reset-password'}"
      class="block mt-3 text-right text-xs text-gray-500 hover:underline"
    >
      Forgot password?
    </router-link>
    <div v-show="type === 'reset' || type === 'login'" class="Separator">
      or
    </div>
    <lm-button-next
      v-show="type === 'signup' || type === 'reset'"
      label="Log in"
      :type="ButtonType.OUTLINE"
      icon="login"
      class="mb-5 mx-auto"
      @click="navigateToLogin"
    />
    <lm-button-next
      label="Create an account"
      :type="ButtonType.OUTLINE"
      icon="openInNew"
      class="mx-auto"
      @click="navigateToSignup"
    />
  </div>
</template>

<script>
import LmButtonNext from '@/components/ui/button/LmButtonNext'
import LmButton from '@/components/ui/LmButton.vue'
import {ButtonType} from '@/lib/definitions'

export default {
  name: 'LoginLayout',
  components: {
    LmButtonNext,
    LmButton
  },
  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    buttonTitle: {
      type: String,
      required: true
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ButtonType
    }
  },
  methods: {
    submit() {
      this.$emit('on-submit')
    },
    navigateToSignup() {
      window.location.href = 'https://www.landscapemonitor.io/signup'
    },
    navigateToLogin() {
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style scoped>
.LoginLayout {
  width: 280px;
  margin: 100px auto 20px;
  .FormTitle,
  .MainButton {
    width: 100%;
  }
  .FormTitle {
    width: 100%;
    margin-bottom: 60px;
    font-size: 22px;
    text-align: center;
  }
  .MainButton {
    margin-top: 50px;
  }
  .Separator {
    position: relative;
    width: 280px;
    margin: 40px 0;
    z-index: 1;
    text-align: center;
    color: theme('colors.gray.700');
    font-size: 13px;
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 30px;
      height: 20px;
      margin: -10px -15px;
      z-index: -1;
      background-color: white;
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 55%;
      width: 100%;
      z-index: -2;
      border-bottom: 1px solid theme('colors.gray.300');
    }
  }
}
</style>
